import styled from 'styled-components';
import { useMst } from '@models/Root';
import { StaffDashboard, StudentDashboard } from '@modules/app';

const HSMSStepContentCardDashboard = styled.div``;

const Dashboard = () => {
  const { student, user } = useMst();

  return (
    <HSMSStepContentCardDashboard>
      {student?.id && <StudentDashboard />}
      {user?.id && <StaffDashboard />}
    </HSMSStepContentCardDashboard>
  );
};

export default Dashboard;
